var exports = {
  "MY": "OAuthAuthorizePage.module__page___cF9QQ3",
  "g4": "OAuthAuthorizePage.module__loadingContainer___cF9QQ3",
  "Un": "OAuthAuthorizePage.module__errorContainer___cF9QQ3",
  "ow": "OAuthAuthorizePage.module__errorContent___cF9QQ3",
  "JU": "OAuthAuthorizePage.module__errorTitle___cF9QQ3",
  "kc": "OAuthAuthorizePage.module__errorText___cF9QQ3",
  "d1": "OAuthAuthorizePage.module__heroCard___cF9QQ3",
  "iC": "OAuthAuthorizePage.module__heroCopy___cF9QQ3",
  "ZY": "OAuthAuthorizePage.module__heroTitle___cF9QQ3",
  "fd": "OAuthAuthorizePage.module__heroDescription___cF9QQ3",
  "$2": "OAuthAuthorizePage.module__cardGrid___cF9QQ3",
  "Ql": "OAuthAuthorizePage.module__accountList___cF9QQ3",
  "ts": "OAuthAuthorizePage.module__sectionDivider___cF9QQ3",
  "nd": "OAuthAuthorizePage.module__panel___cF9QQ3",
  "bV": "OAuthAuthorizePage.module__sectionHeader___cF9QQ3",
  "Gf": "OAuthAuthorizePage.module__sectionTitle___cF9QQ3",
  "yV": "OAuthAuthorizePage.module__sectionDescription___cF9QQ3",
  "s0": "OAuthAuthorizePage.module__inlineStatus___cF9QQ3",
  "Jb": "OAuthAuthorizePage.module__scopeList___cF9QQ3",
  "_9": "OAuthAuthorizePage.module__permissionScrollContainer___cF9QQ3",
  "C6": "OAuthAuthorizePage.module__permissionScroller___cF9QQ3",
  "Mg": "OAuthAuthorizePage.module__permissionList___cF9QQ3",
  "ce": "OAuthAuthorizePage.module__permissionRow___cF9QQ3",
  "Ck": "OAuthAuthorizePage.module__permissionLabel___cF9QQ3",
  "rJ": "OAuthAuthorizePage.module__scopeRow___cF9QQ3",
  "BB": "OAuthAuthorizePage.module__scopeHeading___cF9QQ3",
  "OK": "OAuthAuthorizePage.module__scopeName___cF9QQ3",
  "RJ": "OAuthAuthorizePage.module__scopeDescription___cF9QQ3",
  "Pp": "OAuthAuthorizePage.module__scopeChip___cF9QQ3",
  "p$": "OAuthAuthorizePage.module__emptyState___cF9QQ3",
  "uL": "OAuthAuthorizePage.module__caution___cF9QQ3",
  "iB": "OAuthAuthorizePage.module__dangerNotice___cF9QQ3",
  "mW": "OAuthAuthorizePage.module__successScreen___cF9QQ3",
  "n7": "OAuthAuthorizePage.module__successIconCircle___cF9QQ3",
  "FU": "OAuthAuthorizePage.module__successIcon___cF9QQ3",
  "QK": "OAuthAuthorizePage.module__successTitle___cF9QQ3",
  "s3": "OAuthAuthorizePage.module__successSubtitle___cF9QQ3",
  "cs": "OAuthAuthorizePage.module__successAction___cF9QQ3",
  "By": "OAuthAuthorizePage.module__guildOption___cF9QQ3",
  "rZ": "OAuthAuthorizePage.module__guildValue___cF9QQ3",
  "XN": "OAuthAuthorizePage.module__guildAvatar___cF9QQ3",
  "oM": "OAuthAuthorizePage.module__guildAvatarPlaceholder___cF9QQ3",
  "p2": "OAuthAuthorizePage.module__guildOptionLabel___cF9QQ3",
  "RG": "OAuthAuthorizePage.module__guildOptionDisabled___cF9QQ3",
  "p4": "OAuthAuthorizePage.module__guildOptionNotice___cF9QQ3",
  "A2": "OAuthAuthorizePage.module__actionSection___cF9QQ3",
  "PJ": "OAuthAuthorizePage.module__footerText___cF9QQ3",
  "o1": "OAuthAuthorizePage.module__actions___cF9QQ3",
  "hP": "OAuthAuthorizePage.module__actionButton___cF9QQ3",
};

module.exports = exports;
